import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";

export default function ProtectedRoute({ children }) {
  const { state } = useAuth();
  if (state === "checking") {
    return (
      <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center">
        <div className="text-white/60 text-sm tracking-wide">Loading admin…</div>
      </div>
    );
  }
  if (state !== "authed") {
    return <Navigate to="/admin" replace />;
  }
  return children;
}
